import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import axios from "axios";
import apiUrl from "../../Environment/Api";

function ClientRate() {
  // STATES

  const [category, setCategory] = useState([]);
  const [clientDetails, setClientDetails] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Edit data
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({
    id: "",
    type_id: "",
    type_name: "",
    client_id: "",
    client_name: "",
    value: "",
  });

  // Delete Data
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  // FORM DATA

  const [formData, setFormData] = useState({
    type_id: "",
    type_name: "",
  });

  // CLIENT RATES

  const [clientRates, setClientRates] = useState({});

  // MODAL

  const [showModal, setShowModal] = useState(false);

  // PAGINATION

  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage, setItemsPerPage] = useState(10);

  // FETCH CATEGORY

  const fetchCategory = async () => {
    try {
      const response = await axios.get(`${apiUrl}/category`);

      setCategory(response.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  // FETCH CLIENT DETAILS

  const fetchClientDetails = async () => {
    try {
      const response = await axios.get(`${apiUrl}/clientdetails`);

      setClientDetails(response.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  // FETCH TABLE DATA

  const fetchTableData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/clientrate`);

      const result = response.data || [];

      let formattedData = [];

      result.forEach((typeItem) => {
        typeItem.client_data.forEach((client) => {
          formattedData.push({
            id: client.id,

            type_id: typeItem.type_id,

            type_name: typeItem.type_name,

            client_id: client.client_id,

            client_name: client.clientName,

            value: client.value,
          });
        });
      });

      setTableData(formattedData);

      setFilteredData(formattedData);
    } catch (error) {
      console.log(error);
    }
  };

  // USE EFFECT

  useEffect(() => {
    fetchCategory();

    fetchClientDetails();

    fetchTableData();
  }, []);

  // OPEN MODAL

  const handleNewButtonClick = () => {
    setShowModal(true);
  };

  // CLOSE MODAL

  const handleCloseModal = () => {
    setShowModal(false);

    setFormData({
      type_id: "",
      type_name: "",
    });

    setClientRates({});
  };

  // HANDLE TYPE CHANGE

  const handleTypeChange = (e) => {
    const selectedTypeId = e.target.value;

    const selectedData = category.find(
      (item) => item.type_id === selectedTypeId,
    );

    setFormData({
      type_id: selectedData?.type_id || "",

      type_name: selectedData?.type || "",
    });
  };

  // HANDLE RATE CHANGE

  const handleRateChange = (client, value) => {
    setClientRates((prev) => ({
      ...prev,

      [client.client_id]: value,
    }));
  };

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!formData.type_id || !formData.type_name) {
        alert("Please Select Type");

        return;
      }

      // FORMAT CLIENT DATA
      const client_data = clientDetails
        .filter(
          (client) =>
            clientRates[client.client_id] !== undefined &&
            clientRates[client.client_id] !== "",
        )
        .map((client) => ({
          client_id: client.client_id,

          clientName: client.clientName,

          value: clientRates[client.client_id],
        }));

      if (client_data.length === 0) {
        alert("Please Enter Atleast One Value");

        return;
      }
      // FINAL PAYLOAD
      const payload = {
        type_id: formData.type_id,

        type_name: formData.type_name,

        client_data,
      };

      console.log(payload);
      // API
      await axios.post(`${apiUrl}/clientrate`, payload);
      handleCloseModal();

      fetchTableData();
    } catch (error) {
      console.log(error);

      alert("Error While Saving");
    }
  };

  // Handle edit
  const handleEdit = (item) => {
    setEditData({
      id: item.id,
      type_id: item.type_id,
      type_name: item.type_name,
      client_id: item.client_id,
      client_name: item.client_name,
      value: item.value,
    });

    setShowEditModal(true);
  };

  // HANDLE EDIT CHANGE
  const handleEditChange = (e) => {
    const { name, value } = e.target;

    setEditData((prev) => ({
      ...prev,

      [name]: value,
    }));
  };

  // Update function
  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        type_name: editData.type_name,
        client_id: editData.client_id,
        clientName: editData.client_name,
        value: editData.value,
      };

      await axios.put(`${apiUrl}/clientrate/${editData.id}`, payload);
      setShowEditModal(false);
      fetchTableData();
    } catch (error) {
      console.log(error);

      alert("Update Failed");
    }
  };

  // Delete model
  const handleDeletePopup = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Handle Delete function
  const handleDelete = async () => {
    try {
      await axios.delete(`${apiUrl}/clientrate/${deleteId}`);
      setShowDeleteModal(false);
      fetchTableData();
    } catch (error) {
      console.log(error);
      alert("Delete Failed");
    }
  };

  // SEARCH
  const handlesearchFilter = (e) => {
    const inputValue = e.target.value.toLowerCase();

    const filtered = tableData.filter((data) =>
      Object.values(data).some((value) =>
        value?.toString()?.toLowerCase()?.includes(inputValue),
      ),
    );

    setFilteredData(filtered);

    setCurrentPage(1);
  };

  // PAGINATION

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));

    setCurrentPage(1);
  };

  // JSX

  return (
    <div>
      {/* HEADER */}

      <div className="d-flex">
        <h5 className="mt-2">Client Rate Details</h5>

        <button
          type="button"
          className="btn btn-success mx-2 addbutton-heading"
          onClick={handleNewButtonClick}
        >
          ADD
        </button>
      </div>

      {/* ADD MODAL */}
      <Modal
        className="modal"
        show={showModal}
        onHide={handleCloseModal}
        size="xl"
        centered
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Client Rate</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* TYPE */}

            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <label className="form-label fw-semibold">Type Id / Name</label>

                <select
                  className="form-select"
                  value={formData.type_id}
                  onChange={handleTypeChange}
                  required
                >
                  <option value="">-- Select Type --</option>

                  {[...category]
                    .sort((a, b) => a.type_id.localeCompare(b.type_id))
                    .map((data, idx) => (
                      <option key={idx} value={data.type_id}>
                        {data.type_id} - {data.type}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <label className="form-label fw-semibold">Type Name</label>

                <input
                  type="text"
                  className="form-control"
                  value={formData.type_name}
                  readOnly
                />
              </div>
            </div>

            {/* CLIENT RATE */}

            <div className="row mt-4">
              <b>Client Rate</b>

              {[...clientDetails]
                .sort((a, b) => a.client_id.localeCompare(b.client_id))
                .map((data, idx) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6 col-12 mb-3 mt-2"
                    key={idx}
                  >
                    <label className="form-label fw-semibold">
                      {data.client_id} / {data.clientName}
                    </label>

                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Rate"
                      step="0.01"
                      value={clientRates[data.client_id] || ""}
                      onChange={(e) => handleRateChange(data, e.target.value)}
                    />
                  </div>
                ))}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>

            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* EDIT MODAL */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <form onSubmit={handleUpdate}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Client Rate</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-3">
              <div className="col-6">
                <label className="form-label fw-bold">Type Id</label>

                <input
                  type="text"
                  className="form-control"
                  value={editData.type_id}
                  readOnly
                />
              </div>

              <div className="col-6">
                <label className="form-label fw-bold">Type Name</label>

                <input
                  type="text"
                  className="form-control"
                  value={editData.type_name}
                  readOnly
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <label className="form-label fw-bold">Client Name</label>

                <input
                  type="text"
                  className="form-control"
                  value={editData.client_name}
                  readOnly
                />
              </div>

              <div className="col-6">
                <label className="form-label fw-bold">Value</label>

                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  name="value"
                  value={editData.value}
                  onChange={handleEditChange}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Close
            </Button>

            <Button variant="primary" type="submit">
              Update
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* DELETE MODAL */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Client Rate</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure want to delete?</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Close
          </Button>

          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <hr />

      {/* TABLE */}

      <div className="row">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            <div>
              <label>Show per page:</label>

              <select
                className="form-control"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={5}>5</option>

                <option value={10}>10</option>

                <option value={20}>20</option>

                <option value={50}>50</option>
              </select>
            </div>

            <div>
              <label>Search :</label>

              <input
                className="form-control"
                type="text"
                onChange={handlesearchFilter}
              />
            </div>
          </div>

          <div className="table-responsive mt-3">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="text-center">S.No</th>

                  <th className="text-center">Type Id</th>

                  <th className="text-center">Type Name</th>

                  <th className="text-center">Client Id</th>

                  <th className="text-center">Client Name</th>

                  <th className="text-center">Value</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center p-4">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  currentItems.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>

                      <td className="text-center">{item.type_id}</td>

                      <td className="text-center">{item.type_name}</td>

                      <td className="text-center">{item.client_id}</td>

                      <td className="text-center">{item.client_name}</td>

                      <td className="text-center">$ {item.value}</td>

                      <td className="text-center">
                        <button
                          className="btn btn-secondary btn-sm mx-1"
                          onClick={() => handleEdit(item)}
                        >
                          <i class="fa-solid fa-pen-to-square"></i>
                        </button>

                        <button
                          className="btn btn-danger btn-sm mx-1"
                          onClick={() => handleDeletePopup(item.id)}
                        >
                          <i class="fa-solid fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/* PAGINATION */}
            <nav className="d-flex justify-content-end mt-3">
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>

                {Array.from(
                  {
                    length: Math.ceil(filteredData.length / itemsPerPage),
                  },
                  (_, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ),
                )}

                <li
                  className={`page-item ${
                    currentPage ===
                    Math.ceil(filteredData.length / itemsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientRate;
